import { render, staticRenderFns } from "./ProductLabel.vue?vue&type=template&id=3315bd14&scoped=true&"
import script from "./ProductLabel.vue?vue&type=script&lang=js&"
export * from "./ProductLabel.vue?vue&type=script&lang=js&"
import style0 from "./ProductLabel.vue?vue&type=style&index=0&id=3315bd14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3315bd14",
  null
  
)

export default component.exports